// Helper function to convert SVG to cursor-compatible base64 URL
function createCursorFromSVG(svgContent: string, hotX = 10, hotY = 10): string {
  const base64 = btoa(svgContent);
  return `url(data:image/svg+xml;base64,${base64}) ${hotX} ${hotY}, auto`;
}

const rotationCursorSVG = `<svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_21_602)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.95692 13.992V15.8769C7.95692 15.9817 8.08859 16.0373 8.17747 15.9718L12.0749 13.1248C12.1408 13.0757 12.1408 12.9808 12.0749 12.9317L8.17747 10.0847C8.08859 10.0193 7.95692 10.0782 7.95692 10.1796V12.0613C5.06674 12.0155 2.75262 9.57423 2.95013 6.64867C3.11801 4.13544 5.17866 2.09671 7.70674 1.93637C10.3862 1.7662 12.6642 3.67076 13.0723 6.18726C13.148 6.65522 13.5562 6.99555 14.0335 6.99555C14.6228 6.99555 15.0803 6.47523 14.9882 5.89928C14.4154 2.30942 11.0874 -0.383791 7.22944 0.044898C4.0035 0.404866 1.41287 2.97046 1.04748 6.17744C0.563592 10.3727 3.8422 13.9462 7.95692 13.992Z"
      fill="#fff"
      stroke="#000"
      stroke-width="0.5" />
</g>
<defs>
<clipPath id="clip0_21_602">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>`;

export const rotationCursorBase64 = createCursorFromSVG(rotationCursorSVG);
